import { String } from "@siteimprove/alfa-string";
import { Trampoline } from "@siteimprove/alfa-trampoline";
import { Block } from "../block.js";
import { Rule } from "../rule.js";
/**
 * @public
 */
export class KeyframeRule extends Rule {
    static of(key, declarations) {
        return new KeyframeRule(key, Array.from(declarations));
    }
    _key;
    _style;
    constructor(key, declarations) {
        super("keyframe");
        this._key = key;
        this._style = Block.of(declarations.filter((declaration) => declaration._attachParent(this)));
    }
    get key() {
        return this._key;
    }
    get style() {
        return this._style;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            key: this._key,
            style: this._style.toJSON(),
        };
    }
    toString() {
        const style = this._style.toString();
        return `@keyframe ${this._key} {${style === "" ? "" : `\n${String.indent(style)}\n`}}`;
    }
}
/**
 * @public
 */
(function (KeyframeRule) {
    function isKeyframeRule(value) {
        return value instanceof KeyframeRule;
    }
    KeyframeRule.isKeyframeRule = isKeyframeRule;
    /**
     * @internal
     */
    function fromKeyframeRule(json) {
        return Trampoline.done(KeyframeRule.of(json.key, Block.from(json.style).declarations));
    }
    KeyframeRule.fromKeyframeRule = fromKeyframeRule;
})(KeyframeRule || (KeyframeRule = {}));
//# sourceMappingURL=keyframe.js.map